
export default {
    state: {
        sid:''
    },

    mutations: {
        SET_SID(state,data){
            state.sid = data.sid;
        },
    },

    actions: {
        changeSid({commit},parms){
            commit('SET_SID',parms)   
        },
    },
    namespaced: true
}


// WEBPACK FOOTER //
// ./src/store/modules/allInformationSet.js